import { Config } from '@abiglobalhealth/go-types'

export const getStoredConfig = (): Config | undefined => {
  const lsConfig = localStorage.getItem('config')
  return lsConfig ? (JSON.parse(lsConfig) as Config) : undefined
}
